import { render, staticRenderFns } from "./goods-return.vue?vue&type=template&id=1c422e5c"
import script from "./goods-return.vue?vue&type=script&lang=js"
export * from "./goods-return.vue?vue&type=script&lang=js"
import style0 from "./goods-return.vue?vue&type=style&index=0&id=1c422e5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports